function SuccessStories() {
    return (
        <div>
            <h1>successStories</h1>
        </div>
    )
}

export default SuccessStories
